// Import dependencies
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { setStatusItem } from '@automator/builder/services/item';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-status-switch' )
export class AutomatorBuilderItemStatusSwitch extends LitElement {
	// Properties
	// The item type (e.g. `"trigger"`)
	@property( { type: String, attribute: 'item-type' } ) accessor itemType;

	// The item ID (post ID)
	@property( { type: Number, attribute: 'item-id' } ) accessor itemID;

	// Whether the item is `published` (true) or `draft` (false)
	@property( { type: Boolean, attribute: 'is-item-on' } ) accessor isOn;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-switch
				?checked=${ this.isOn }
				status-label=${ `${ escapeHTML( __( 'Live', 'uncanny-automator' ) ) },${ escapeHTML( __( 'Draft', 'uncanny-automator' ) ) }` }
				status-label-position="left"

				@change=${ this.handleSwitchStatus }
			></uo-switch>
		`;
	}

	/**
	 * Handles switching the status
	 *
	 * @param {Event} event The change event
	 */
	handleSwitchStatus( event ) {
		setStatusItem(
			this.itemType,
			this.itemID,
			event.target.checked
		).catch( error => {
			// The action was cancelled by the user
			console.log( error );
		} );
	}
}
